// extracted by mini-css-extract-plugin
module.exports = {"title":"_d9f419","featuresList":"_3eaec6","featureName":"_59e763"};